import React from 'react'
import { Link } from 'react-router-dom'

/**
 * CtaSection — centered call-to-action with grid background and two action buttons.
 */
export default function CtaSection() {
  return (
    <section className="section section-cta" id="journey" aria-label="Begin Your AI-Native Journey">
      <div className="container">
        <div className="cta-content" data-animate="fade-up">

          <h2 className="cta-heading">Begin Your AI-Native Journey</h2>

          <div className="cta-supporting">
            <p>
              Whether building intelligent applications or transforming existing
              architectures, AugmentAppz helps accelerate enterprise execution.
            </p>
          </div>

          <div className="cta-actions">
            <a href="https://studio.qraptor.ai/auth/realms/qraptor/protocol/openid-connect/auth?response_type=code&client_id=qraptor-gateway&scope=openid%20profile%20email&state=oIHXu5lxUKUS9wqKFAyh7PBgyB9rSulquyMGd1pIN6g%3D&redirect_uri=https://studio.qraptor.ai/login/oauth2/code/keycloak&nonce=pT864Gld8PM7yZdbCM_rocra-pLk2k3A5SSRU6LwpRY" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg">
              Explore the Platform
              <svg className="btn-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </a>
            <Link
              to="/contact"
              className="btn btn-outline btn-lg"
            >
              Talk to Our Experts
            </Link>
          </div>

        </div>
      </div>
    </section>
  )
}
